<template>
  <header class="header">
    <div class="header__container container">
      <h1 class="header__title text-lp-h1 mb-3">
        {{ $t('tutorials.tutorials') }}
      </h1>
      <p class="header__description dark-grey--text">
        {{ $t('tutorials.hereWeProvide') }}
      </p>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
};
</script>

<style lang="scss" scoped>
.header {
  margin-top: 5rem;
  &__container {
    max-width: 49.375rem;
    @media #{$md-and-up} {
      padding: 0 !important;
    }
  }
  &__description {
    @media #{$lg-and-up} {
      font-size: 1.5rem;
      line-height: 1.33;
    }
  }
}
</style>
